import { useContext } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { FieldArrayWithId } from 'react-hook-form';
import { EatingWaySettingContext, FormValues } from '../EatingWaySettingModal';
import EatingWaySettingRow from '../EatingWaySettingRow';

export interface EatingWaySettingRowListProps {
  data: FieldArrayWithId<FormValues, 'eatingWaySettings', 'key'>[];
}

function EatingWaySettingRowList({ data }: EatingWaySettingRowListProps) {
  const eatingWaySettingContext = useContext(EatingWaySettingContext);

  return (
    <Droppable droppableId="root">
      {(provided, snapshot) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          style={eatingWaySettingContext.getListStyle(snapshot.isDraggingOver)}
        >
          {data.map((field, index) => (
            <EatingWaySettingRow key={`${field.key}`} rowData={field} rowIndex={index} />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default EatingWaySettingRowList;
